import { Grid, Typography } from '@mui/material';
import { usePqrDataSfc } from './hook';
import { PqrDataSfcProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';
import { pqrStatusSmartList } from '../../../../../../shared/types/modules/pqr';
import FieldText from '../../../../../components/general/fields/fieldText';

export const PqrDataSfc = (props: PqrDataSfcProps) => {
    const {
        formik,
        channelPresentsFailures,
        controlEntities,
        desistItems,
        receptionInstances,
        receptionPoints,
        countries,
        locations,
        markingItems,
        admissions,
        isDcf,
        acceptances,
        rectifications,
        isRectification,
        isInFavorOf,
        isRequest,
        isSfc,
        isRequiredLocation,
        fraudTypes,
        fraudModes,
        isFraud,
        isRequiredFraudParams,
    } = usePqrDataSfc(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Datos PQR SFC
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(countries)}
                    label="País"
                    name="country"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.country}
                    errors={formik.errors.country}
                    value={formik.values.country}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('country', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(locations)}
                    label="Ubicación PQR"
                    name="location"
                    size="small"
                    required={isRequiredLocation}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.location}
                    errors={formik.errors.location}
                    value={formik.values.location}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('location', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(channelPresentsFailures)}
                    label="Canal qué presentó falla"
                    name="channelPresentsFailure"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.channelPresentsFailure}
                    errors={formik.errors.channelPresentsFailure}
                    value={formik.values.channelPresentsFailure}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('channelPresentsFailure', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Es tutela?"
                    checked={Boolean(formik.values.isGuardianship)}
                    onChange={() => {
                        formik.setFieldValue(
                            'isGuardianship',
                            !formik.values.isGuardianship
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de tutela"
                    name="guardianship"
                    size="small"
                    required={Boolean(formik.values.isGuardianship)}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.guardianship}
                    errors={formik.errors.guardianship}
                    value={formik.values.guardianship}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(controlEntities)}
                    label="Ente de control"
                    name="controlEntity"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.controlEntity}
                    errors={formik.errors.controlEntity}
                    value={formik.values.controlEntity}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('controlEntity', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Escalamiento DCF"
                    checked={Boolean(formik.values.dcfScaling)}
                    onChange={() => {
                        formik.setFieldValue(
                            'dcfScaling',
                            !formik.values.dcfScaling
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(desistItems)}
                    label="Desistimiento"
                    name="desistd"
                    size="small"
                    required
                    disabled={!isDcf}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.desistd}
                    errors={formik.errors.desistd}
                    value={formik.values.desistd}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('desistd', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Es una queja express?"
                    checked={Boolean(formik.values.hasExpressComplaint)}
                    onBlur={formik.handleBlur}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionInstances)}
                    label="Instancia de recepción"
                    name="receptionInstance"
                    size="small"
                    required
                    disabled={isRequest && isSfc}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionInstance}
                    errors={formik.errors.receptionInstance}
                    value={formik.values.receptionInstance}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionInstance', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionPoints)}
                    label="Punto de recepción"
                    name="receptionPoint"
                    size="small"
                    required
                    disabled={Boolean(formik.values.receptionPoint)}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionPoint}
                    errors={formik.errors.receptionPoint}
                    value={formik.values.receptionPoint}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionPoint', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(admissions)}
                    label="Admisión"
                    name="admission"
                    size="small"
                    required
                    disabled={!isDcf}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.admission}
                    errors={formik.errors.admission}
                    value={formik.values.admission}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('admission', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(pqrStatusSmartList)}
                    label="Estado"
                    name="status"
                    size="small"
                    required
                    disabled
                    value={formik.values.status}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Es producto virtual?"
                    checked={Boolean(formik.values.isVirtualProduct)}
                    onChange={() => {
                        formik.setFieldValue(
                            'isVirtualProduct',
                            !formik.values.isVirtualProduct
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            {isInFavorOf && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(acceptances)}
                        label="Aceptación"
                        name="acceptance"
                        size="small"
                        required
                        disabled={!isDcf}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.acceptance}
                        errors={formik.errors.acceptance}
                        value={formik.values.acceptance}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('acceptance', value)
                        }
                    />
                </Grid>
            )}
            {isRectification && (
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(rectifications)}
                        label="Rectificación"
                        name="rectification"
                        size="small"
                        required
                        disabled={!isDcf}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.rectification}
                        errors={formik.errors.rectification}
                        value={formik.values.rectification}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('rectification', value)
                        }
                    />
                </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="¿Es prorroga?"
                    checked={Boolean(formik.values.isExtension)}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Anexos a la respuesta final"
                    checked={Boolean(formik.values.finalResponseAttached)}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(markingItems)}
                    label="Marcación"
                    name="marking"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.marking}
                    errors={formik.errors.marking}
                    value={formik.values.marking}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('marking', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(fraudTypes)}
                    label="Tipología de fraude"
                    name="fraudType"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.fraudType}
                    errors={formik.errors.fraudType}
                    value={formik.values.fraudType}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('fraudType', value)
                    }
                    disabled={!isFraud}
                    required={isRequiredFraudParams}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(fraudModes)}
                    label="Modalidad de fraude"
                    name="fraudMode"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.fraudMode}
                    errors={formik.errors.fraudMode}
                    value={formik.values.fraudMode}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('fraudMode', value)
                    }
                    disabled={!isFraud}
                    required={isRequiredFraudParams}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Monto reclamado"
                    type="number"
                    name="claimedAmount"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.claimedAmount}
                    errors={formik.errors.claimedAmount}
                    value={formik.values.claimedAmount}
                    onChange={formik.handleChange}
                    disabled={!isFraud}
                    required={isRequiredFraudParams}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Monto reconocido"
                    type="number"
                    name="approvedAmount"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.approvedAmount}
                    errors={formik.errors.approvedAmount}
                    value={formik.values.approvedAmount}
                    onChange={formik.handleChange}
                    disabled={!isFraud}
                    required={isRequiredFraudParams}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DateTimePickerField
                    label="Fecha cierre DCF"
                    name="closingDateDCF"
                    size="small"
                    touched={formik.touched.closingDateDCF}
                    errors={formik.errors.closingDateDCF?.toString()}
                    value={
                        formik.values.closingDateDCF
                            ? dayjs(formik.values.closingDateDCF)
                            : undefined
                    }
                    onChange={(value) =>
                        formik.setFieldValue('closingDateDCF', value, true)
                    }
                    disabled={!props.isClousureStatus || !isDcf}
                    minDate={dayjs(formik.values.updateStatusPQRDate)}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DateTimePickerField
                    label="Fecha y hora radicación cliente"
                    name="customerFilingDate"
                    size="small"
                    touched={formik.touched.customerFilingDate}
                    errors={formik.errors.customerFilingDate?.toString()}
                    value={
                        formik.values.customerFilingDate
                            ? dayjs(formik.values.customerFilingDate)
                            : undefined
                    }
                    onChange={(value) =>
                        formik.setFieldValue('customerFilingDate', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DateTimePickerField
                    label="Fecha actualización estado PQR"
                    name="updateStatusPQRDate"
                    size="small"
                    touched={formik.touched.updateStatusPQRDate}
                    errors={formik.errors.updateStatusPQRDate?.toString()}
                    value={dayjs(formik.values.updateStatusPQRDate)}
                    onChange={(value) =>
                        formik.setFieldValue('updateStatusPQRDate', value, true)
                    }
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DateTimePickerField
                    label="Fecha respuesta SFC"
                    name="answerSFCDate"
                    size="small"
                    touched={formik.touched.answerSFCDate}
                    errors={formik.errors.answerSFCDate?.toString()}
                    value={
                        formik.values.answerSFCDate
                            ? dayjs(formik.values.answerSFCDate)
                            : undefined
                    }
                    onChange={(value) =>
                        formik.setFieldValue('answerSFCDate', value, true)
                    }
                    disabled={!props.isClousureStatus || isDcf}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Detalle del producto"
                    name="detailProduct"
                    size="small"
                    required
                    rows={2}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.detailProduct}
                    errors={formik.errors.detailProduct}
                    value={formik.values.detailProduct}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
